/**
 * File name: [AlertContainer.jsx]
 * Description: [Allows you to display the 'ALERT' element from the 'useReactToastify.jsx' hook in other project elements]
 *
 */

import React from "react";
import { ToastContainer } from "react-toastify";

const AlertContainer = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  );
};

export default AlertContainer;
